import {
    NgModule
} from '@angular/core';
import {
    BrowserModule
} from '@angular/platform-browser';
import {
    BrowserAnimationsModule
} from '@angular/platform-browser/animations';
import {
    FormsModule
} from '@angular/forms';
import {
    HttpClientModule
} from '@angular/common/http';
import {
    IonicModule
} from '@ionic/angular';
import {
    IonicStorageModule
} from '@ionic/storage';
import {
    ApperyioModule
} from './scripts/apperyio/apperyio.module';
import {
    ApperyioDeclarablesModule
} from './scripts/apperyio/declarables/apperyio.declarables.module';
import {
    PipesModule
} from './scripts/pipes.module';
import {
    DirectivesModule
} from './scripts/directives.module';
import {
    ComponentsModule
} from './scripts/components.module';
import {
    CustomComponentsModule
} from './scripts/custom-components.module';
import {
    CustomModulesModule
} from './scripts/custom-modules.module';
import {
    Sanitizer
} from '@angular/core';
import {
    NgDompurifySanitizer
} from '@tinkoff/ng-dompurify';
import {
    createTranslateLoader
} from './scripts/apperyio/translate_module';
import {
    TranslateModule
} from '@ngx-translate/core';
import {
    TranslateLoader
} from '@ngx-translate/core';
import {
    HttpClient
} from '@angular/common/http';
import {
    app
} from './app';
import {
    AppRoutingModule
} from './app-routing.module';
import {
    ExportedClass as HotelApp_login_service
} from './scripts/services/HotelApp_login_service';
import {
    ExportedClass as HotelApp_logout_service
} from './scripts/services/HotelApp_logout_service';
import {
    ExportedClass as HostGator_HostGator_AABB_PDV_Datos_PDV_get
} from './scripts/services/HostGator_HostGator_AABB_PDV_Datos_PDV_get';
import {
    ExportedClass as HostGator_HostGator_AABB_PDV_Dato_PDV_get
} from './scripts/services/HostGator_HostGator_AABB_PDV_Dato_PDV_get';
import {
    ExportedClass as HotelApp_me_service
} from './scripts/services/HotelApp_me_service';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_Spa_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_Spa_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Cartas_CartaCompleta_get
} from './scripts/services/HostGator_HostGator_AABB_Cartas_CartaCompleta_get';
import {
    ExportedClass as HotelApp_PDV_read_service
} from './scripts/services/HotelApp_PDV_read_service';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_Dispo_Tratamientos_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_Dispo_Tratamientos_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_ReservarSpa_put
} from './scripts/services/HostGator_HostGator_RESORT_SPA_ReservarSpa_put';
import {
    ExportedClass as HostGator_HostGator_AABB_Cartas_Platos_Room_get
} from './scripts/services/HostGator_HostGator_AABB_Cartas_Platos_Room_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_MisReservasSpa_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_MisReservasSpa_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_HorariosDisponibles_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_HorariosDisponibles_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_PDVs_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_PDVs_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_Servicios_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_Servicios_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_CantPersonas_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_CantPersonas_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_ReservarResto_put
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_ReservarResto_put';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_MisReservasResto_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_MisReservasResto_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_addToCart_put
} from './scripts/services/HostGator_HostGator_AABB_Carro_addToCart_put';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_borrarCarro_delete
} from './scripts/services/HostGator_HostGator_AABB_Carro_borrarCarro_delete';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_hacerPedido_post
} from './scripts/services/HostGator_HostGator_AABB_Carro_hacerPedido_post';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_ElCarroEstaVacio_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_ElCarroEstaVacio_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_totalCarro_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_totalCarro_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_listarCarro_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_listarCarro_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Cartas_Servicios_x_PDV_get
} from './scripts/services/HostGator_HostGator_AABB_Cartas_Servicios_x_PDV_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_listarPedidos_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_listarPedidos_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_Resort_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_Resort_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ActividadesDisponibles_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ActividadesDisponibles_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarActividad_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarActividad_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_MisReservasActividades_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_MisReservasActividades_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Cartas_Platos_x_PDV_y_Servicio_get
} from './scripts/services/HostGator_HostGator_AABB_Cartas_Platos_x_PDV_y_Servicio_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_Tipo_Spa_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_Tipo_Spa_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_Tipo_Tratamiento_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_Tipo_Tratamiento_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_Tipo_Actividades_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_Tipo_Actividades_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_SPA_Tipo_Spa_Unico_get
} from './scripts/services/HostGator_HostGator_RESORT_SPA_Tipo_Spa_Unico_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ActividadesExtraDisponibles_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ActividadesExtraDisponibles_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ListarActividadesExtra_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ListarActividadesExtra_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarActividadExtra_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarActividadExtra_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_Golf_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_Golf_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ListarActividades_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ListarActividades_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ActividadesIndoorDisponibles_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ActividadesIndoorDisponibles_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarPiscina_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarPiscina_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_CantPersonasResort_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_CantPersonasResort_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarPiscinaNew_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarPiscinaNew_put';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_ControlFechaCheckOut_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_ControlFechaCheckOut_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarCanchas_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarCanchas_put';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_ControlHuespedDesayuno_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_ControlHuespedDesayuno_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_HorariosPreferencia1_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_HorariosPreferencia1_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_HorariosPreferencia2_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_HorariosPreferencia2_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_ConfirmarHorariosDesayuno_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_ConfirmarHorariosDesayuno_get';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_IdiomaMapas_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_IdiomaMapas_get';
import {
    ExportedClass as HotelApp_user_update_service
} from './scripts/services/HotelApp_user_update_service';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_HorarioRoomService_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_HorarioRoomService_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_CantPersonasDesayuno_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_CantPersonasDesayuno_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_HorariosDisponiblesDesayuno_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_HorariosDisponiblesDesayuno_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_put
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_put';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_listarCarroOpciones_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_listarCarroOpciones_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_borrarCarroOpciones_delete
} from './scripts/services/HostGator_HostGator_AABB_Carro_borrarCarroOpciones_delete';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_listarPedidosOpciones_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_listarPedidosOpciones_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_ElCarroEstaVacioOpciones_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_ElCarroEstaVacioOpciones_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_hacerPedidoOpciones_post
} from './scripts/services/HostGator_HostGator_AABB_Carro_hacerPedidoOpciones_post';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_totalCarroOpciones_get
} from './scripts/services/HostGator_HostGator_AABB_Carro_totalCarroOpciones_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Carro_addToCartOpciones_put
} from './scripts/services/HostGator_HostGator_AABB_Carro_addToCartOpciones_put';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_MisReservasDesayuno_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_MisReservasDesayuno_get';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_ReservarRestoNew_put
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_ReservarRestoNew_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarActividad_New_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarActividad_New_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarPiscina_New_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarPiscina_New_put';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ListarGruposNahuelitos_get
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ListarGruposNahuelitos_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_ReservarNahuelitos_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_ReservarNahuelitos_put';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_ControlHuesped_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_ControlHuesped_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_HorariosDesayunoDisponibles_get
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_HorariosDesayunoDisponibles_get';
import {
    ExportedClass as HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_New_put
} from './scripts/services/HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_New_put';
import {
    ExportedClass as HostGator_HostGator_AABB_ReservasRestaurant_CancelarReservaAABB_get
} from './scripts/services/HostGator_HostGator_AABB_ReservasRestaurant_CancelarReservaAABB_get';
import {
    ExportedClass as HostGator_HostGator_RESORT_RESORT_CancelarReservaResort_put
} from './scripts/services/HostGator_HostGator_RESORT_RESORT_CancelarReservaResort_put';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_Banners_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_Banners_get';
import {
    ExportedClass as HostGator_HostGator_Varios_Controles_Secciones_get
} from './scripts/services/HostGator_HostGator_Varios_Controles_Secciones_get';
import {
    InAppBrowser
} from '@ionic-native/in-app-browser/ngx';
import {
    WebView
} from '@ionic-native/ionic-webview/ngx';
import {
    Device
} from '@ionic-native/device/ngx';
import {
    SplashScreen
} from '@ionic-native/splash-screen/ngx';
import {
    StatusBar
} from '@ionic-native/status-bar/ngx';
import {
    Keyboard
} from '@ionic-native/keyboard/ngx';
import {
    Network
} from '@ionic-native/network/ngx';
import {
    SecureStorage
} from '@ionic-native/secure-storage/ngx';
( < any > NgDompurifySanitizer.prototype)._sanitize_fn = NgDompurifySanitizer.prototype.sanitize;
NgDompurifySanitizer.prototype.sanitize = function(...args) {
    let value: any = args[1];
    if (value && value.hasOwnProperty("changingThisBreaksApplicationSecurity")) {
        args[1] = value.changingThisBreaksApplicationSecurity
    }
    return this._sanitize_fn(...args);
}
var getIonicModuleConfig, getIonicStorageModuleConfig;
@NgModule({
    declarations: [
        app
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        IonicModule.forRoot((typeof getIonicModuleConfig === "function")? getIonicModuleConfig(): undefined),
        HttpClientModule,
        ApperyioModule,
        PipesModule,
        DirectivesModule,
        ComponentsModule,
        ApperyioDeclarablesModule,
        CustomComponentsModule,
        CustomModulesModule,
        IonicStorageModule.forRoot((typeof getIonicStorageModuleConfig === "function")? getIonicStorageModuleConfig(): undefined),
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })
    ],
    bootstrap: [
        app
    ],
    entryComponents: [
        //app
    ],
    providers: [
        StatusBar,
        SplashScreen,
        WebView,
        Device,
        Keyboard,
        Network,
        SecureStorage,
        {
            provide: Sanitizer,
            useClass: NgDompurifySanitizer,
        },
        InAppBrowser,
        HotelApp_login_service,
        HotelApp_logout_service,
        HostGator_HostGator_AABB_PDV_Datos_PDV_get,
        HostGator_HostGator_AABB_PDV_Dato_PDV_get,
        HotelApp_me_service,
        HostGator_HostGator_RESORT_SPA_Spa_get,
        HostGator_HostGator_AABB_Cartas_CartaCompleta_get,
        HotelApp_PDV_read_service,
        HostGator_HostGator_RESORT_SPA_Dispo_Tratamientos_get,
        HostGator_HostGator_RESORT_SPA_ReservarSpa_put,
        HostGator_HostGator_AABB_Cartas_Platos_Room_get,
        HostGator_HostGator_RESORT_SPA_MisReservasSpa_get,
        HostGator_HostGator_AABB_ReservasRestaurant_HorariosDisponibles_get,
        HostGator_HostGator_AABB_ReservasRestaurant_PDVs_get,
        HostGator_HostGator_AABB_ReservasRestaurant_Servicios_get,
        HostGator_HostGator_AABB_ReservasRestaurant_CantPersonas_get,
        HostGator_HostGator_AABB_ReservasRestaurant_ReservarResto_put,
        HostGator_HostGator_AABB_ReservasRestaurant_MisReservasResto_get,
        HostGator_HostGator_AABB_Carro_addToCart_put,
        HostGator_HostGator_AABB_Carro_borrarCarro_delete,
        HostGator_HostGator_AABB_Carro_hacerPedido_post,
        HostGator_HostGator_AABB_Carro_ElCarroEstaVacio_get,
        HostGator_HostGator_AABB_Carro_totalCarro_get,
        HostGator_HostGator_AABB_Carro_listarCarro_get,
        HostGator_HostGator_AABB_Cartas_Servicios_x_PDV_get,
        HostGator_HostGator_AABB_Carro_listarPedidos_get,
        HostGator_HostGator_RESORT_RESORT_Resort_get,
        HostGator_HostGator_RESORT_RESORT_ActividadesDisponibles_get,
        HostGator_HostGator_RESORT_RESORT_ReservarActividad_put,
        HostGator_HostGator_RESORT_RESORT_MisReservasActividades_get,
        HostGator_HostGator_AABB_Cartas_Platos_x_PDV_y_Servicio_get,
        HostGator_HostGator_RESORT_SPA_Tipo_Spa_get,
        HostGator_HostGator_RESORT_SPA_Tipo_Tratamiento_get,
        HostGator_HostGator_RESORT_RESORT_Tipo_Actividades_get,
        HostGator_HostGator_RESORT_SPA_Tipo_Spa_Unico_get,
        HostGator_HostGator_RESORT_RESORT_ActividadesExtraDisponibles_get,
        HostGator_HostGator_RESORT_RESORT_ListarActividadesExtra_get,
        HostGator_HostGator_RESORT_RESORT_ReservarActividadExtra_put,
        HostGator_HostGator_RESORT_RESORT_Golf_get,
        HostGator_HostGator_RESORT_RESORT_ListarActividades_get,
        HostGator_HostGator_RESORT_RESORT_ActividadesIndoorDisponibles_get,
        HostGator_HostGator_RESORT_RESORT_ReservarPiscina_put,
        HostGator_HostGator_RESORT_RESORT_CantPersonasResort_get,
        HostGator_HostGator_RESORT_RESORT_ReservarPiscinaNew_put,
        HostGator_HostGator_Varios_Controles_ControlFechaCheckOut_get,
        HostGator_HostGator_RESORT_RESORT_ReservarCanchas_put,
        HostGator_HostGator_Varios_Controles_ControlHuespedDesayuno_get,
        HostGator_HostGator_AABB_Desayuno_HorariosPreferencia1_get,
        HostGator_HostGator_AABB_Desayuno_HorariosPreferencia2_get,
        HostGator_HostGator_AABB_Desayuno_ConfirmarHorariosDesayuno_get,
        HostGator_HostGator_Varios_Controles_IdiomaMapas_get,
        HotelApp_user_update_service,
        HostGator_HostGator_Varios_Controles_HorarioRoomService_get,
        HostGator_HostGator_AABB_Desayuno_CantPersonasDesayuno_get,
        HostGator_HostGator_AABB_Desayuno_HorariosDisponiblesDesayuno_get,
        HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_put,
        HostGator_HostGator_AABB_Carro_listarCarroOpciones_get,
        HostGator_HostGator_AABB_Carro_borrarCarroOpciones_delete,
        HostGator_HostGator_AABB_Carro_listarPedidosOpciones_get,
        HostGator_HostGator_AABB_Carro_ElCarroEstaVacioOpciones_get,
        HostGator_HostGator_AABB_Carro_hacerPedidoOpciones_post,
        HostGator_HostGator_AABB_Carro_totalCarroOpciones_get,
        HostGator_HostGator_AABB_Carro_addToCartOpciones_put,
        HostGator_HostGator_AABB_Desayuno_MisReservasDesayuno_get,
        HostGator_HostGator_AABB_ReservasRestaurant_ReservarRestoNew_put,
        HostGator_HostGator_RESORT_RESORT_ReservarActividad_New_put,
        HostGator_HostGator_RESORT_RESORT_ReservarPiscina_New_put,
        HostGator_HostGator_RESORT_RESORT_ListarGruposNahuelitos_get,
        HostGator_HostGator_RESORT_RESORT_ReservarNahuelitos_put,
        HostGator_HostGator_Varios_Controles_ControlHuesped_get,
        HostGator_HostGator_AABB_Desayuno_HorariosDesayunoDisponibles_get,
        HostGator_HostGator_AABB_Desayuno_ReservarDesayuno_New_put,
        HostGator_HostGator_AABB_ReservasRestaurant_CancelarReservaAABB_get,
        HostGator_HostGator_RESORT_RESORT_CancelarReservaResort_put,
        HostGator_HostGator_Varios_Controles_Banners_get,
        HostGator_HostGator_Varios_Controles_Secciones_get,
    ]
})
export class AppModule {}